import PropTypes from 'prop-types';
import React from 'react';
import {FormattedMessage} from 'react-intl';
import classNames from 'classnames';
import {Tab, Tabs, TabList, TabPanel} from 'react-tabs';
import tabStyles from 'react-tabs/style/react-tabs.css';

import Box from '../box/box.jsx';
import Modal from '../modal/modal.jsx';
import styles from './rb-account-modal.css';


const tabClassNames = {
    tabs: styles.tabs,
    tab: classNames(tabStyles.reactTabsTab, styles.tab),
    tabList: classNames(tabStyles.reactTabsTabList, styles.tabList),
    tabPanel: classNames(tabStyles.reactTabsTabPanel, styles.tabPanel),
    tabPanelSelected: classNames(tabStyles.reactTabsTabPanelSelected, styles.isSelected),
    tabSelected: classNames(tabStyles.reactTabsTabSelected, styles.isSelected)
};

const RbAccountModal = props => (

    <Modal
        className={styles.modalContent}
        contentLabel={
            <FormattedMessage
                defaultMessage="My Account"
                description=""
                id="rb.gui.accoutModal.myAccount"
            />
        }
        onRequestClose={props.onCancel}
    >
        <Box className={styles.body}>
            <Box className={styles.flexWrapper}>
                <Box className={styles.editorWrapper}>
                    <Box>
                        <Tabs
                            className={tabClassNames.tabs}
                            selectedIndex={props.activeTabIndex}
                            selectedTabClassName={tabClassNames.tabSelected}
                            selectedTabPanelClassName={tabClassNames.tabPanelSelected}
                            onSelect={props.onActivateTab}
                        >
                            <TabList className={tabClassNames.tabList}>
                                <Tab className={tabClassNames.tab}>
                                    <FormattedMessage
                                        defaultMessage="Log In"
                                        description=""
                                        id="rb.gui.accoutModal.login"
                                    />
                                </Tab>
                                <Tab className={tabClassNames.tab}>
                                    <FormattedMessage
                                        defaultMessage="Sign Up"
                                        description=""
                                        id="rb.gui.accoutModal.signup"
                                    />
                                </Tab>
                            </TabList>
                            <TabPanel className={tabClassNames.tabPanel}>
                                <form className={styles.form}>
                                    {props.loginMessage ? (
                                        <div className={styles.alertDanger}>
                                            {props.loginMessage}
                                        </div>
                                    ) : null}
                                    <div className={styles.formGroup}>
                                        <label>
                                            <FormattedMessage
                                                defaultMessage="Email address"
                                                description=""
                                                id="rb.gui.accoutModal.email"
                                            />
                                        </label>
                                        <input
                                            className={styles.formControl}
                                            type="email"
                                            value={props.loginEmail}
                                            onChange={props.onChangeLoginEmail}
                                        />
                                        <div
                                            className={styles.invalidFeedback}
                                            style={{display: props.loginEmailIsValid ? 'none' : 'block'}}
                                        >
                                            <FormattedMessage
                                                defaultMessage="Please enter a valid email address"
                                                description=""
                                                id="rb.gui.accoutModal.emailValidMsg"
                                            />
                                        </div>
                                    </div>
                                    <div className={styles.formGroup}>
                                        <label>
                                            <FormattedMessage
                                                defaultMessage="Password"
                                                description=""
                                                id="rb.gui.accoutModal.password"
                                            />
                                        </label>
                                        <input
                                            className={styles.formControl}
                                            type="password"
                                            value={props.loginPassword}
                                            onChange={props.onChangeLoginPassword}
                                        />
                                        <div
                                            className={styles.invalidFeedback}
                                            style={{display: props.loginPasswordIsValid ? 'none' : 'block'}}
                                        >
                                            <FormattedMessage
                                                defaultMessage="Please enter a value between 6 and 16 characters long"
                                                description=""
                                                id="rb.gui.accountModal.passwordValidMsg"
                                            />
                                        </div>
                                    </div>
                                </form>
                            </TabPanel>
                            <TabPanel className={tabClassNames.tabPanel}>
                                <form className={styles.form}>
                                    {props.signupMessage ? (
                                        <div className={styles.alertDanger}>
                                            {props.signupMessage}
                                        </div>
                                    ) : null}
                                    <div className={styles.formGroup}>
                                        <label>
                                            <FormattedMessage
                                                defaultMessage="Username"
                                                description=""
                                                id="rb.gui.accoutModal.username"
                                            />
                                        </label>
                                        <input
                                            className={styles.formControl}
                                            type="text"
                                            value={props.signupUsername}
                                            onChange={props.onChangeSignupUsername}
                                        />
                                        <div
                                            className={styles.invalidFeedback}
                                            style={{display: props.signupUsernameIsValid ? 'none' : 'block'}}
                                        >
                                            <FormattedMessage
                                                defaultMessage="Username must contain only letters, numbers, hyphens and underscores between 6 and 16 characters long"
                                                description=""
                                                id="rb.gui.accountModal.usernameValidMsg"
                                            />
                                        </div>
                                    </div>
                                    <div className={styles.formGroup}>
                                        <label>
                                            <FormattedMessage
                                                defaultMessage="Email address"
                                                description=""
                                                id="rb.gui.accoutModal.email"
                                            />
                                        </label>
                                        <input
                                            className={styles.formControl}
                                            type="email"
                                            value={props.signupEmail}
                                            onChange={props.onChangeSignupEmail}
                                        />
                                        <div
                                            className={styles.invalidFeedback}
                                            style={{display: props.signupEmailIsValid ? 'none' : 'block'}}
                                        >
                                            <FormattedMessage
                                                defaultMessage="Please enter a valid email address"
                                                description=""
                                                id="rb.gui.accoutModal.emailValidMsg"
                                            />
                                        </div>
                                    </div>
                                    <div className={styles.formGroup}>
                                        <label>
                                            <FormattedMessage
                                                defaultMessage="Password"
                                                description=""
                                                id="rb.gui.accoutModal.password"
                                            />
                                        </label>
                                        <input
                                            className={styles.formControl}
                                            type="password"
                                            value={props.signupPassword}
                                            onChange={props.onChangeSignupPassword}
                                        />
                                        <div
                                            className={styles.invalidFeedback}
                                            style={{display: props.signupPasswordIsValid ? 'none' : 'block'}}
                                        >
                                            <FormattedMessage
                                                defaultMessage="Please enter a value between 6 and 16 characters long"
                                                description=""
                                                id="rb.gui.accountModal.passwordValidMsg"
                                            />
                                        </div>
                                    </div>
                                </form>
                            </TabPanel>
                        </Tabs>
                    </Box>
                    <Box className={styles.buttonRow}>
                        {props.activeTabIndex === 1 ? (
                            <button
                                className={styles.connectButton}
                                type="button"
                                onClick={props.onSignUp}
                            >
                                <FormattedMessage
                                    defaultMessage="Sign Up"
                                    description=""
                                    id="rb.gui.accoutModal.signup"
                                />
                            </button>
                        ) : (
                            <button
                                className={styles.connectButton}
                                type="button"
                                onClick={props.onLogin}
                            >
                                <FormattedMessage
                                    defaultMessage="Log In"
                                    description=""
                                    id="rb.gui.accoutModal.login"
                                />
                            </button>
                        )}

                    </Box>
                </Box>
            </Box>
        </Box>
    </Modal>
);

RbAccountModal.propTypes = {
    activeTabIndex: PropTypes.number,
    loginEmail: PropTypes.string.isRequired,
    loginEmailIsValid: PropTypes.bool.isRequired,
    loginMessage: PropTypes.string.isRequired,
    loginPassword: PropTypes.string.isRequired,
    loginPasswordIsValid: PropTypes.bool.isRequired,
    onActivateTab: PropTypes.func,
    onCancel: PropTypes.func.isRequired,
    onChangeLoginEmail: PropTypes.func.isRequired,
    onChangeLoginPassword: PropTypes.func.isRequired,
    onChangeSignupEmail: PropTypes.func.isRequired,
    onChangeSignupPassword: PropTypes.func.isRequired,
    onChangeSignupUsername: PropTypes.func.isRequired,
    onLogin: PropTypes.func.isRequired,
    onSignUp: PropTypes.func.isRequired,
    signupEmail: PropTypes.string.isRequired,
    signupEmailIsValid: PropTypes.bool.isRequired,
    signupMessage: PropTypes.string.isRequired,
    signupPassword: PropTypes.string.isRequired,
    signupPasswordIsValid: PropTypes.bool.isRequired,
    signupUsername: PropTypes.string.isRequired,
    signupUsernameIsValid: PropTypes.bool.isRequired
};

export default RbAccountModal;
